export { default as version } from './version';
export * from './components/Configure';
export * from './components/DynamicWidgets';
export * from './components/Index';
export * from './components/InstantSearch';
export * from './components/InstantSearchServerContext';
export * from './components/InstantSearchSSRProvider';
export * from './connectors/useAutocomplete';
export * from './connectors/useBreadcrumb';

export const useChat = () => {
  throw new Error(
    `"useChat()" is not available from the UMD build.

Please use React InstantSearch with a packaging system:
https://www.algolia.com/doc/guides/building-search-ui/installation/react/#install-react-instantsearch-as-an-npm-package`
  );
};

export * from './connectors/useClearRefinements';
export * from './connectors/useConfigure';
export * from './connectors/useCurrentRefinements';
export * from './connectors/useDynamicWidgets';
export * from './connectors/useFrequentlyBoughtTogether';
export * from './connectors/useGeoSearch';
export * from './connectors/useHierarchicalMenu';
export * from './connectors/useHits';
export * from './connectors/useHitsPerPage';
export * from './connectors/useInfiniteHits';
export * from './connectors/useMenu';
export * from './connectors/useNumericMenu';
export * from './connectors/usePagination';
export * from './connectors/usePoweredBy';
export * from './connectors/useQueryRules';
export * from './connectors/useRange';
export * from './connectors/useRefinementList';
export * from './connectors/useRelatedProducts';
export * from './connectors/useSearchBox';
export * from './connectors/useSortBy';
export * from './connectors/useStats';
export * from './connectors/useToggleRefinement';
export * from './connectors/useTrendingItems';
export * from './connectors/useLookingSimilar';
export * from './hooks/useConnector';
export * from './hooks/useInstantSearch';
export * from './lib/wrapPromiseWithState';
export * from './lib/useInstantSearchContext';
export * from './lib/useRSCContext';
export * from './lib/InstantSearchRSCContext';
export * from './lib/InstantSearchSSRContext';
export * from './server';
